interface Props {
  children: React.ReactNode
}

export function WallpaperBackground({ children }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background bg-cover bg-center bg-no-repeat bg-[url(/pictures/Bonisoft_wallpaper_light.png)] dark:bg-[url(/pictures/Bonisoft_wallpaper_dark.png)]">
      {children}
    </div>
  )
}
